export const isLocalDev = () => {
  return location.hostname === "localhost";
};
